@if (shouldShowDateHeader) {
<div class="chat-date-header">
  <span class="chat-date-badge">
    {{ isToday(message.createdAt) ? 'Today' : isYesterday(message.createdAt) ? 'Yesterday' : (message.createdAt |
    date:'MMMM d, y') }}
  </span>
</div>
}

<div [id]="'msg-' + (message._id || message.id || message.messageId)" class="message-item-wrapper"
  [class.system-message-row]="isSystemMessage(message)"
  [class.chat-box-sender]="!isSystemMessage(message) && userId === message.sender_id"
  [class.chat-box-receiver]="!isSystemMessage(message) && userId !== message.sender_id"
  [class.has-reactions]="hasReactions(message)"
  [class.has-active-menu]="activeMessageMenuId === (message._id || message.id || message.messageId)">

  @if (isSystemMessage(message)) {
  <div class="system-message-content d-flex flex-column align-items-center">
    <div class="system-message-container position-relative d-inline-flex align-items-start justify-content-center">
      @if (getModuleInfo(message); as modInfo) {
      @if (modInfo.code === 'finance' || modInfo.code === 'lead-track' || modInfo.code === 'tasks') {
      <span class="outside-vertical-label" [class.outside-label-finance]="modInfo.code === 'finance'"
        [class.outside-label-lead-track]="modInfo.code === 'lead-track'"
        [class.outside-label-tasks]="modInfo.code === 'tasks'">
        {{ modInfo.label }}
      </span>
      }
      }
      <span class="system-message-badge" [class.system-badge-closed]="getSystemMessageData(message).isClosedStatus"
        [class.system-badge-lost]="getSystemMessageData(message).isLostStatus">
        @if (getSystemMessageData(message).isStatusUpdate) {
        <span [innerHTML]="formatFollowUpText(getSystemMessageData(message).prefixText, message)"></span>
        <span class="status-pill-badge" [style.color]="getSystemMessageData(message).statusStyle.textColor"
          [style.backgroundColor]="getSystemMessageData(message).statusStyle.bgColor"
          [style.borderColor]="getSystemMessageData(message).statusStyle.borderColor">
          {{ getSystemMessageData(message).status }}
        </span>
        @if (getSystemMessageData(message).timeText) {
        <span class="system-message-time">{{ getSystemMessageData(message).timeText }}</span>
        } @else if (message.createdAt) {
        <span class="system-message-time">( {{ message.createdAt | date:'hh:mm a - MMM d, y' }} )</span>
        }
        } @else if (getSystemMessageData(message).isAlert) {
        <span class="alert-title-prefix" [class.alert-title-red]="getSystemMessageData(message).isFollowUpAlert"
          [style.color]="getSystemMessageData(message).isFollowUpAlert ? '#dc2626' : 'inherit'"
          style="font-weight: 700;">
          {{ getSystemMessageData(message).alertTitle }}
        </span>
        <span [innerHTML]="formatFollowUpText(getSystemMessageData(message).alertBody, message)"></span>
        @if (message.createdAt && !getSystemMessageData(message).alertBody?.includes('(')) {
        <span class="system-message-time">
          ( {{ message.createdAt | date:'hh:mm a - MMM d, y' }} )
        </span>
        }
        } @else {
        <span [innerHTML]="formatFollowUpText(message.systemText || message.message, message)"></span>
        @if (message.createdAt && !(message.systemText || message.message)?.includes('(')) {
        <span class="system-message-time">
          ( {{ message.createdAt | date:'hh:mm a - MMM d, y' }} )
        </span>
        }
        }
        @if (isAlertMessage(message)) {
        <span class="alert-info-link" (click)="onAlertLinkClick($event)">
          - click for more info...
        </span>
        }
      </span>
    </div>
  </div>
  }

  <!-- REGULAR MESSAGE (SENDER OR RECEIVER) -->
  @if (!isSystemMessage(message)) {

  <!-- Receiver Profile Image -->
  @if (userId !== message.sender_id && isGroupChat) {
  <div class="receiver-profile" (click)="onMemberClick(message.sender_id); $event.stopPropagation()"
    title="Chat with {{ userNameMapping[message.sender_id] || 'User' }}">
    <img [src]="profileImageMapping[message.sender_id] || 'assets/user-icon.png'"
      (error)="handleProfileImageError($event)" class="profile-img" />
  </div>
  }

  <div class="message-content-box" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd($event)" (touchcancel)="onTouchCancel()" (mousedown)="onMouseDown($event)"
    (click)="onContentBoxClick($event)" [style.transform]="getSwipeTransform()"
    [style.transition]="getSwipeTransition()">

    <!-- Receiver Name -->
    @if (userId !== message.sender_id && isGroupChat) {
    <p class="receiver-name" (click)="onMemberClick(message.sender_id); $event.stopPropagation()"
      title="Chat with {{ userNameMapping[message.sender_id] || 'User' }}">
      {{ userNameMapping[message.sender_id] || 'User' }}
    </p>
    }

    <div class="bubble-container position-relative" (contextmenu)="onContextMenu($event)"
      [class.has-active-menu]="activeMessageMenuId === (message._id || message.id || message.messageId)"
      [class.chat-text-sender]="userId === message.sender_id" [class.chat-text-receiver]="userId !== message.sender_id"
      [class.is-gif-bubble]="isGifMessage(message)" [class.is-uploading]="message.isUploading"
      [class.has-reply-msg]="message.replyTo || message.meta?.replyTo"
      [class.has-media-content]="getFilesFromMessage(message).length > 0 || isGifMessage(message)"
      [class.has-audio-content]="isAudioMessage(message)" [class.has-only-docs]="hasOnlyDocuments(message)"
      [class.receiver-short-text]="userId !== message.sender_id && message.message && message.message.length < 30 && !isURL(message.message) && !getFilesFromMessage(message).length">
      <!-- Swipe to Reply Indicator -->
      <div class="swipe-reply-indicator" [class.threshold-reached]="isSwipeThresholdReached"
        [style.opacity]="getSwipeIndicatorOpacity()" [style.transform]="getSwipeIndicatorTransform()"
        aria-hidden="true">
        <svg viewBox="0 0 24 24" class="swipe-reply-svg">
          <path fill="currentColor" d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" />
        </svg>
      </div>

      <!-- Pinned Indicator -->
      @if (isMessagePinned(message._id || message.id || message.messageId)) {
      <span class="pin-styled-icon" [class.pin-text-message]="!getFilesFromMessage(message).length" title="Pinned">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <path fill="#dc3545"
            d="M16.729 4.271a1 1 0 0 0-1.414-.004a1 1 0 0 0-.225.355c-.832 1.736-1.748 2.715-2.904 3.293C10.889 8.555 9.4 9 7 9a1.01 1.01 0 0 0-.923.617a1 1 0 0 0 .217 1.09l3.243 3.243L5 20l6.05-4.537l3.242 3.242a1 1 0 0 0 .326.217q.185.077.382.078c.197.001.26-.027.382-.078A1 1 0 0 0 16 18c0-2.4.444-3.889 1.083-5.166c.577-1.156 1.556-2.072 3.293-2.904a1 1 0 0 0 .354-.225a1 1 0 0 0-.004-1.414z">
          </path>
        </svg>
      </span>
      }

      <!-- Upload Overlay -->
      @if (message.isUploading) {
      <div class="upload-overlay">
        <div class="upload-progress-container">
          <div class="ring-wrapper">
            <svg class="progress-ring" width="50" height="50">
              <circle class="progress-ring__circle-bg" stroke="rgba(255, 255, 255, 0.2)" stroke-width="3"
                fill="transparent" r="22" cx="25" cy="25" />
              <circle class="progress-ring__circle" stroke="white" stroke-width="3" fill="transparent" r="22" cx="25"
                cy="25" [style.strokeDashoffset]="138 - (138 * (message.progress || uploadProgress)) / 100"
                stroke-dasharray="138 138" stroke-linecap="round" />
            </svg>
            <div class="cancel-upload-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </div>
          <div class="upload-percent-text">{{ message.progress || uploadProgress }}%</div>
        </div>
      </div>
      }

      <!-- Message Menu Trigger -->
      <div class="dropdown message-options"
        [class.has-active-menu]="activeMessageMenuId === (message._id || message.id || message.messageId)"
        [class.is-context-menu]="contextMenuTop !== null" [style.top.px]="contextMenuTop"
        [style.left.px]="contextMenuLeft" (click)="$event.stopPropagation()">
        <div class="menu-trigger text-muted" (mousedown)="$event.preventDefault()" (click)="onMenuTriggerClick($event)"
          [class.active]="activeMessageMenuId === (message._id || message.id || message.messageId)">
          <svg viewBox="0 0 19 20" height="20" width="19" preserveAspectRatio="xMidYMid meet">
            <path fill="currentColor" d="M3.8,6.7l5.7,5.7l5.7-5.7l1.6,1.6l-7.3,7.3L2.2,8.3L3.8,6.7z"></path>
          </svg>
        </div>

        <app-message-menu [message]="message"
          [isActive]="activeMessageMenuId === (message._id || message.id || message.messageId)"
          [commonReactions]="commonReactions"
          [isPinned]="isMessagePinned(message._id || message.id || message.messageId)" [isStarred]="isMessageStarred()"
          [userId]="userId" [isGroupChat]="isGroupChat" [isNoLongerMember]="isNoLongerMember"
          (reply)="reply.emit($event)" (replyPrivately)="replyPrivately.emit($event)" (forward)="forward.emit($event)"
          (edit)="edit.emit($event)" (deleteForEveryone)="delete.emit({ message: $event, forEveryone: true })"
          (deleteForMe)="delete.emit({ message: $event, forEveryone: false })" (pinMessage)="pin.emit($event)"
          (unpinMessage)="unpin.emit($event)" (starMessage)="star.emit($event)" (unstarMessage)="unstar.emit($event)"
          (quickReactionSelect)="reaction.emit({ emoji: $event.emoji, messageId: $event.messageId })"
          (openReactionPicker)="fullReactionPicker.emit($event)" (seenInfo)="seenInfo.emit($event)"
          (makeTask)="makeTask.emit($event)"
          (closeMenu)="activeMessageMenuId = null; contextMenuTop = null; contextMenuLeft = null">
        </app-message-menu>
      </div>

      <!-- Reply Context -->
      @if (message.replyTo || message.meta?.replyTo) {
      <div class="reply-context-bubble"
        (click)="scrollToMessage.emit({ id: (message.replyTo || message.meta.replyTo).id || (message.replyTo || message.meta.replyTo)._id, replyTo: (message.replyTo || message.meta.replyTo) }); $event.stopPropagation()">
        <div class="reply-inner-wrapper">
          <div class="reply-content">
            <span class="reply-sender-name text-truncate">
              {{ getReplySenderName(message.replyTo || message.meta.replyTo) }}
              @if ((message.replyTo || message.meta.replyTo).sourceGroupName) {
              <span class="reply-source-group ml-1"
                (click)="onGroupSourceClick($event, (message.replyTo || message.meta.replyTo))"
                title="Go to {{ (message.replyTo || message.meta.replyTo).sourceGroupName }}">
                • {{ (message.replyTo || message.meta.replyTo).sourceGroupName }}
              </span>
              }
            </span>

            @if (getReplyThumbnail(message.replyTo || message.meta.replyTo)) {
            <div class="reply-media-row">
              @if (getReplyMediaTypeIcon(message.replyTo || message.meta.replyTo)) {
              <img [src]="getReplyMediaTypeIcon(message.replyTo || message.meta.replyTo)" width="16" height="16" />
              }
              <span>
                {{ getReplyMediaType(message.replyTo || message.meta.replyTo) }}
                @if (
                getReplyMediaType(message.replyTo || message.meta.replyTo) === 'Video' &&
                getReplyDuration(message.replyTo || message.meta.replyTo)
                ) {
                <span>({{ getReplyDuration(message.replyTo || message.meta.replyTo) }})</span>
                }
              </span>
            </div>
            }

            @if (!getReplyThumbnail(message.replyTo || message.meta.replyTo)) {
            <p class="reply-text">
              @if (getReplyMediaType(message.replyTo || message.meta.replyTo) === 'Voice Message') {
              <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;vertical-align: middle;">
                <path fill="currentColor"
                  d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                <path fill="currentColor"
                  d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
              </svg>
              }
              {{ getReplyMessageText(message.replyTo || message.meta.replyTo) }}
            </p>
            }
          </div>

          @if (getReplyThumbnail(message.replyTo || message.meta.replyTo)) {
          <div class="reply-thumbnail">
            <img [src]="getReplyThumbnail(message.replyTo || message.meta.replyTo)" />
          </div>
          }
        </div>
      </div>
      }

      <!-- Forwarded Indicator -->
      @if (message.meta?.isForwarded) {
      <div class="forwarded-indicator d-flex justify-content-start align-items-center"
        [class.sender]="userId === message.sender_id">
        <svg style="margin-right: 4px" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
          <path fill="currentColor" d="m15 5l-1.41 1.41L18.17 11H2V13h16.17l-4.59 4.59L15 19l7-7z" />
        </svg>
        <p class="forwarded-text">Forwarded from {{ message.meta?.forwardedFrom || 'Unknown' }}</p>
      </div>
      }

      <!-- CONTENT AREA -->
      <div class="message-body-inner">

        <!-- MULTIPLE FILES -->
        @if (getFilesFromMessage(message).length > 1 && hasOnlyDocuments(message)) {
        <div class="telegram-files-list">
          @for (file of getFilesFromMessage(message); track file.fileUrl || file.name; let i = $index) {
          <div class="telegram-file-row" (click)="previewDocument(file, $event)" [title]="getDisplayFileName(file.name)">
            <div class="tg-doc-badge-container">
              <svg class="tg-doc-badge-svg" width="38" height="42" viewBox="0 0 42 46" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0C2.686 0 0 2.686 0 6V40C0 43.314 2.686 46 6 46H36C39.314 46 42 43.314 42 40V12L30 0H6Z"
                  [attr.fill]="getFileBadgeColor(file.name)" />
                <path d="M30 0V8C30 10.209 31.791 12 34 12H42L30 0Z" fill="rgba(255, 255, 255, 0.3)" />
                <text x="20" y="31" font-size="15" font-weight="500" fill="#ffffff" text-anchor="middle"
                  letter-spacing="0.5px">
                  {{ getFileExtLabel(file.name) }}
                </text>
              </svg>
            </div>
            <div class="tg-doc-info">
              <span class="tg-doc-name" [title]="getDisplayFileName(file.name)">{{ getDisplayFileName(file.name)
                }}</span>
              @if (file.size) {
              <div class="tg-doc-meta">
                <span class="tg-doc-size">{{ formatSize(file.size) }}</span>
              </div>
              }
            </div>
            <a class="tg-doc-download-btn" [href]="file.fileUrl" [download]="getDisplayFileName(file.name)"
              (click)="downloadFile(file, $event)" title="Download {{ getDisplayFileName(file.name) }}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </a>
          </div>
          }
          @if (message.meta?.caption && !isMessageRedundantWithFile(message)) {
          <p class="media-caption mb-0 mt-2"
            [class.fwd-caption]="message.meta?.isForwarded && userId === message.sender_id"
            [class.fwd-caption-receiver]="message.meta?.isForwarded && userId !== message.sender_id"
            [innerHTML]="getDisplayMessage(message.meta.caption, (message._id || message.id || message.messageId))">
          </p>
          @if (isMessageLong(message.meta.caption)) {
          <span class="read-more-link"
            (click)="toggleMessageExpand(message._id || message.id || message.messageId); $event.stopPropagation()">
            {{ isMessageExpanded(message._id || message.id || message.messageId) ? ' Show less' : ' Read more' }}
          </span>
          }
          }
        </div>
        }
        @else if (getFilesFromMessage(message).length > 1) {
        <div class="files-carousel-container">
          <div class="carousel-wrapper">
            <div class="carousel-inner">
              @for (file of getFilesFromMessage(message); track file.fileUrl; let i = $index) {
              <div class="carousel-item" [class.active]="(message.currentSlideIndex || 0) === i">

                @if (file.type?.startsWith('image/')) {
                <div class="image-box" (click)="onImageClick(file, i)">
                  <img [src]="file.fileUrl" class="img-fluid" />
                </div>
                }

                @if (file.type?.startsWith('video/') && !file.name.includes('voice_message_')) {
                <div class="video-box" (click)="onImageClick(file, i)">
                  <video [src]="file.fileUrl" controls class="embed-responsive"
                    (click)="$event.stopPropagation()"></video>
                </div>
                }

                @if (file.type?.startsWith('audio/') || file.name.includes('voice_message_')) {
                <div class="telegram-audio-box" [class.voice-message-ui]="isAudioVoiceMessage(file)">
                  <div class="audio-main">

                    @if (isAudioVoiceMessage(file)) {
                    <div class="voice-avatar-container">
                      <img [src]="getAudioAvatar()" class="voice-avatar-img" (error)="handleProfileImageError($event)">
                      <div class="voice-mic-icon">
                        <svg viewBox="0 0 24 24" width="11" height="11">
                          <path fill="currentColor"
                            d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                          <path fill="currentColor"
                            d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                        </svg>
                      </div>
                    </div>

                    <div class="voice-play-wrapper">
                      <button type="button" class="audio-play-btn" (click)="toggleAudio($event, audioPlayer)"
                        [attr.aria-label]="isPlaying ? 'Pause' : 'Play'" [title]="isPlaying ? 'Pause' : 'Play'">
                        @if (!isPlaying) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                          fill="currentColor">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                        } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                          fill="currentColor">
                          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                        </svg>
                        }
                      </button>

                      <button type="button" class="audio-download-badge" (click)="downloadAudioFile(file, $event)"
                        title="Download audio" aria-label="Download audio">
                        <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor"
                          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                          <polyline points="7 10 12 15 17 10"></polyline>
                          <line x1="12" y1="15" x2="12" y2="3"></line>
                        </svg>
                      </button>
                    </div>
                    } @else {
                    <div class="music-play-wrapper">
                      <button type="button" class="audio-play-btn music-play-btn"
                        (click)="toggleAudio($event, audioPlayer)"
                        [attr.aria-label]="isPlaying ? 'Pause' : (currentTime > 0 ? 'Resume' : 'Play')"
                        [title]="isPlaying ? 'Pause' : (currentTime > 0 ? 'Resume' : 'Play')">
                        @if (isPlaying) {
                        <svg class="music-icon-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                          viewBox="0 0 24 24" fill="currentColor">
                          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                        </svg>
                        } @else if (currentTime > 0) {
                        <svg class="music-icon-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                          viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                        } @else {
                        <svg class="music-icon-svg default-music-icon" viewBox="0 0 24 24" width="20" height="20"
                          fill="currentColor">
                          <path
                            d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
                        </svg>
                        <svg class="music-icon-svg hover-play-icon" xmlns="http://www.w3.org/2000/svg" width="20"
                          height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                        }
                      </button>

                      <button type="button" class="audio-download-badge" (click)="downloadAudioFile(file, $event)"
                        title="Download audio" aria-label="Download audio">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                          <polyline points="7 10 12 15 17 10"></polyline>
                          <line x1="12" y1="15" x2="12" y2="3"></line>
                        </svg>
                      </button>
                    </div>
                    }

                    <div class="audio-info">
                      @if (!isAudioVoiceMessage(file)) {
                      <p class="audio-name" [title]="file.name">{{ file.name }}</p>
                      }

                      <div class="voice-scrubber-wrapper">
                        <div class="audio-waveform-container" [style.--progress]="getProgressPercent() + '%'">
                          <div class="waveform-bars">
                            @for (height of waveformBars; track $index) {
                            <div class="wave-bar" [style.height.%]="height"></div>
                            }
                          </div>
                          <div class="waveform-bars filled"
                            [style.clip-path]="'inset(0 calc(100% - ' + getProgressPercent() + '%) 0 0)'">
                            @for (height of waveformBars; track $index) {
                            <div class="wave-bar" [style.height.%]="height"></div>
                            }
                          </div>
                          <div class="waveform-thumb" [style.left]="getProgressPercent() + '%'"></div>
                          <input type="range" class="audio-slider voice-slider" [min]="0"
                            [max]="totalDurationRaw || 100" [value]="currentTime" (input)="onSeek($event, audioPlayer)"
                            (click)="$event.stopPropagation()" aria-label="Seek audio">
                        </div>
                      </div>

                      <div class="voice-meta-row">
                        <div class="voice-time-group">
                          <span class="voice-current-time">{{ currentTimeDisplay || '0:00' }}</span>
                          <span class="voice-time-separator">/</span>
                          <span class="voice-duration">{{ getAudioTotalDuration() }}</span>
                        </div>

                        <button type="button" class="audio-speed-btn" (click)="toggleAudioSpeed($event, audioPlayer)"
                          title="Playback speed">
                          {{ playbackSpeed }}x
                        </button>
                      </div>
                    </div>
                  </div>
                  <audio #audioPlayer [src]="getAudioFileUrl(file)" preload="metadata" style="display:none"
                    (ended)="onAudioEnded()" (loadedmetadata)="onMetadataLoaded(audioPlayer)"
                    (timeupdate)="onTimeUpdate(audioPlayer)"></audio>
                </div>
                }
                @if (!file.type?.startsWith('image/') && !file.type?.startsWith('video/') &&
                !file.type?.startsWith('audio/') && !file.name.includes('voice_message_')) {
                <div class="telegram-file-row carousel-doc-row" (click)="previewDocument(file, $event)"
                  [title]="getDisplayFileName(file.name)">
                  <div class="tg-doc-badge-container">
                    <svg class="tg-doc-badge-svg" width="38" height="42" viewBox="0 0 42 46" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6 0C2.686 0 0 2.686 0 6V40C0 43.314 2.686 46 6 46H36C39.314 46 42 43.314 42 40V12L30 0H6Z"
                        [attr.fill]="getFileBadgeColor(file.name)" />
                      <path d="M30 0V8C30 10.209 31.791 12 34 12H42L30 0Z" fill="rgba(255, 255, 255, 0.3)" />
                      <text x="20" y="31" font-size="15" font-weight="500" fill="#ffffff" text-anchor="middle"
                        letter-spacing="0.5px">
                        {{ getFileExtLabel(file.name) }}
                      </text>
                    </svg>
                  </div>
                  <div class="tg-doc-info">
                    <span class="tg-doc-name" [title]="getDisplayFileName(file.name)">{{ getDisplayFileName(file.name)
                      }}</span>
                    @if (file.size) {
                    <div class="tg-doc-meta">
                      <span class="tg-doc-size">{{ formatSize(file.size) }}</span>
                    </div>
                    }
                  </div>
                  <a class="tg-doc-download-btn" [href]="file.fileUrl" [download]="getDisplayFileName(file.name)"
                    (click)="downloadFile(file, $event)" title="Download {{ getDisplayFileName(file.name) }}">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                  </a>
                </div>
                }

              </div>
              }
            </div>

            <!-- Carousel Controls -->
            <div class="carousel-controls">
              <button class="carousel-control prev" (click)="prevSlide(message)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6l1.41-1.42z" />
                </svg>
              </button>
              <div class="carousel-indicators">
                <span>{{ (message.currentSlideIndex || 0) + 1 }} / {{ getFilesFromMessage(message).length }}</span>
              </div>
              <button class="carousel-control next" (click)="nextSlide(message)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z" />
                </svg>
              </button>
            </div>
          </div>

          @if (message.meta?.caption && !isMessageRedundantWithFile(message)) {
          <p class="media-caption mb-0 mt-2"
            [class.fwd-caption]="message.meta?.isForwarded && userId === message.sender_id"
            [class.fwd-caption-receiver]="message.meta?.isForwarded && userId !== message.sender_id"
            [innerHTML]="getDisplayMessage(message.meta.caption, (message._id || message.id || message.messageId))">
          </p>
          @if (isMessageLong(message.meta.caption)) {
          <span class="read-more-link"
            (click)="toggleMessageExpand(message._id || message.id || message.messageId); $event.stopPropagation()">
            {{ isMessageExpanded(message._id || message.id || message.messageId) ? ' Show less' : ' Read more' }}
          </span>
          }
          }
        </div>
        }

        <!-- SINGLE FILE / MEDIA -->
        @if (getFilesFromMessage(message).length === 1 && !isGifMessage(message)) {
        <div class="single-media-container">
          @switch (isVoiceMessage(message) ? 'audio' :
          (isDocumentFile(getFilesFromMessage(message)[0]) ? 'document' :
          getFilesFromMessage(message)[0].type?.split('/')[0])) {

          @case ('image') {
          <div class="image-box" (click)="onImageClick(getFilesFromMessage(message)[0], 0)">
            <img [src]="getFilesFromMessage(message)[0].fileUrl" class="img-fluid" />
          </div>
          }

          @case ('video') {
          <div class="video-box" (click)="onImageClick(getFilesFromMessage(message)[0], 0)">
            <video [src]="getFilesFromMessage(message)[0].fileUrl" controls class="embed-responsive"
              (click)="$event.stopPropagation()"></video>
          </div>
          }

          @case ('audio') {
          <div class="telegram-audio-box" [class.voice-message-ui]="isAudioVoiceMessage()">
            <div class="audio-main">

              @if (isAudioVoiceMessage()) {
              <div class="voice-avatar-container">
                <img [src]="getAudioAvatar()" class="voice-avatar-img" (error)="handleProfileImageError($event)">
                <div class="voice-mic-icon">
                  <svg viewBox="0 0 24 24" width="11" height="11">
                    <path fill="currentColor"
                      d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                    <path fill="currentColor"
                      d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                  </svg>
                </div>
              </div>

              <div class="voice-play-wrapper">
                <button type="button" class="audio-play-btn" (click)="toggleAudio($event, audioPlayer)"
                  [attr.aria-label]="isPlaying ? 'Pause' : 'Play'" [title]="isPlaying ? 'Pause' : 'Play'">
                  @if (!isPlaying) {
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                  } @else {
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                  </svg>
                  }
                </button>

                <button type="button" class="audio-download-badge"
                  (click)="downloadAudioFile(getFilesFromMessage(message)[0], $event)" title="Download audio"
                  aria-label="Download audio">
                  <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                </button>
              </div>
              } @else {
              <div class="music-play-wrapper">
                <button type="button" class="audio-play-btn music-play-btn" (click)="toggleAudio($event, audioPlayer)"
                  [attr.aria-label]="isPlaying ? 'Pause' : (currentTime > 0 ? 'Resume' : 'Play')"
                  [title]="isPlaying ? 'Pause' : (currentTime > 0 ? 'Resume' : 'Play')">
                  @if (isPlaying) {
                  <svg class="music-icon-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                    viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                  </svg>
                  } @else if (currentTime > 0) {
                  <svg class="music-icon-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                    viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                  } @else {
                  <svg class="music-icon-svg default-music-icon" viewBox="0 0 24 24" width="20" height="20"
                    fill="currentColor">
                    <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
                  </svg>
                  <svg class="music-icon-svg hover-play-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                    viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                  }
                </button>

                <button type="button" class="audio-download-badge"
                  (click)="downloadAudioFile(getFilesFromMessage(message)[0], $event)" title="Download audio"
                  aria-label="Download audio">
                  <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                </button>
              </div>
              }

              <div class="audio-info">
                @if (!isAudioVoiceMessage()) {
                <p class="audio-name" [title]="getFilesFromMessage(message)[0]?.name">{{
                  getFilesFromMessage(message)[0]?.name }}</p>
                }

                <div class="voice-scrubber-wrapper">
                  <div class="audio-waveform-container" [style.--progress]="getProgressPercent() + '%'">
                    <div class="waveform-bars">
                      @for (height of waveformBars; track $index) {
                      <div class="wave-bar" [style.height.%]="height"></div>
                      }
                    </div>
                    <div class="waveform-bars filled"
                      [style.clip-path]="'inset(0 calc(100% - ' + getProgressPercent() + '%) 0 0)'">
                      @for (height of waveformBars; track $index) {
                      <div class="wave-bar" [style.height.%]="height"></div>
                      }
                    </div>
                    <div class="waveform-thumb" [style.left]="getProgressPercent() + '%'"></div>
                    <input type="range" class="audio-slider voice-slider" [min]="0" [max]="totalDurationRaw || 100"
                      [value]="currentTime" (input)="onSeek($event, audioPlayer)" (click)="$event.stopPropagation()"
                      aria-label="Seek audio">
                  </div>
                </div>

                <div class="voice-meta-row">
                  <div class="voice-time-group">
                    <span class="voice-current-time">{{ currentTimeDisplay || '0:00' }}</span>
                    <span class="voice-time-separator">/</span>
                    <span class="voice-duration">{{ getAudioTotalDuration() }}</span>
                  </div>

                  <button type="button" class="audio-speed-btn" (click)="toggleAudioSpeed($event, audioPlayer)"
                    title="Playback speed">
                    {{ playbackSpeed }}x
                  </button>
                </div>
              </div>
            </div>
            <!-- Hidden native audio for functionality -->
            <audio #audioPlayer [src]="getAudioFileUrl()" preload="metadata" style="display:none"
              (ended)="onAudioEnded()" (loadedmetadata)="onMetadataLoaded(audioPlayer)"
              (timeupdate)="onTimeUpdate(audioPlayer)"></audio>
          </div>
          }
          @default {
          <div class="telegram-file-row single-doc-row" (click)="previewDocument(getFilesFromMessage(message)[0], $event)"
            [title]="getDisplayFileName(getFilesFromMessage(message)[0].name)">
            <div class="tg-doc-badge-container">
              <svg class="tg-doc-badge-svg" width="38" height="42" viewBox="0 0 42 46" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0C2.686 0 0 2.686 0 6V40C0 43.314 2.686 46 6 46H36C39.314 46 42 43.314 42 40V12L30 0H6Z"
                  [attr.fill]="getFileBadgeColor(getFilesFromMessage(message)[0].name)" />
                <path d="M30 0V8C30 10.209 31.791 12 34 12H42L30 0Z" fill="rgba(255, 255, 255, 0.3)" />
                <text x="20" y="31" font-size="15" font-weight="500" fill="#ffffff" text-anchor="middle"
                  letter-spacing="0.5px">
                  {{ getFileExtLabel(getFilesFromMessage(message)[0].name) }}
                </text>
              </svg>
            </div>
            <div class="tg-doc-info">
              <span class="tg-doc-name" [title]="getDisplayFileName(getFilesFromMessage(message)[0].name)">{{
                getDisplayFileName(getFilesFromMessage(message)[0].name) }}</span>
              @if (getFilesFromMessage(message)[0].size) {
              <div class="tg-doc-meta">
                <span class="tg-doc-size">{{ formatSize(getFilesFromMessage(message)[0].size) }}</span>
              </div>
              }
            </div>
            <a class="tg-doc-download-btn" [href]="getFilesFromMessage(message)[0].fileUrl"
              [download]="getDisplayFileName(getFilesFromMessage(message)[0].name)"
              (click)="downloadFile(getFilesFromMessage(message)[0], $event)"
              title="Download {{ getDisplayFileName(getFilesFromMessage(message)[0].name) }}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </a>
          </div>
          }

          }

          @if ((message.meta?.caption || message.message) && !isMessageRedundantWithFile(message)) {
          <p class="media-caption mb-0 mt-2"
            [class.fwd-caption]="message.meta?.isForwarded && userId === message.sender_id"
            [class.fwd-caption-receiver]="message.meta?.isForwarded && userId !== message.sender_id" [innerHTML]="getDisplayMessage(message.meta?.caption || message.message, (message._id || message.id ||
            message.messageId))">
          </p>
          @if (isMessageLong(message.meta?.caption || message.message)) {
          <span class="read-more-link"
            (click)="toggleMessageExpand(message._id || message.id || message.messageId); $event.stopPropagation()">
            {{ isMessageExpanded(message._id || message.id || message.messageId) ? ' Show less' : ' Read more' }}
          </span>
          }
          }
        </div>
        }

        <!-- GIF MESSAGE -->
        @if (isGifMessage(message)) {
        <div class="gif-message-container"
          [class.has-caption]="(message.meta?.caption || message.message) && !isMessageRedundantWithFile(message)">
          <div class="gif-media-wrapper">
            <span class="gif-indicator">GIF</span>
            @if (!message._gifError) {
            <img [src]="getGifUrl(message)" class="chat-gif-img" (error)="handleGifError($event, message)" alt="GIF" />
            } @else {
            <div class="gif-fallback-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <span class="gif-fallback-text">GIF unavailable</span>
            </div>
            }
          </div>
          @if ((message.meta?.caption || message.message) && !isMessageRedundantWithFile(message)) {
          <p class="media-caption mb-0 mt-2"
            [class.fwd-caption]="message.meta?.isForwarded && userId === message.sender_id"
            [class.fwd-caption-receiver]="message.meta?.isForwarded && userId !== message.sender_id" [innerHTML]="getDisplayMessage(message.meta?.caption || message.message, (message._id || message.id ||
            message.messageId))">
          </p>
          @if (isMessageLong(message.meta?.caption || message.message)) {
          <span class="read-more-link"
            (click)="toggleMessageExpand(message._id || message.id || message.messageId); $event.stopPropagation()">
            {{ isMessageExpanded(message._id || message.id || message.messageId) ? ' Show less' : ' Read more' }}
          </span>
          }
          }
        </div>
        }

        <!-- TEXT / LINK MESSAGE -->
        @if (
        message.message &&
        !isMessageRedundantWithFile(message) &&
        !isGifMessage(message) &&
        getFilesFromMessage(message).length === 0
        ) {
        <div class="text-container">

          <!-- Link Preview -->
          @if (isURL(message.message)) {
          <div class="url-preview" (click)="openUrl(message.message)">
            <p class="link-url">{{ message.message }}</p>

            @if (hasLinkMeta(message)) {
            <div class="telegram-preview-content" [class.icon-mode]="isIconMode(message)">
              <div class="preview-text-content">
                @if (message.meta?.title) {
                <p class="meta-title">{{ message.meta.title }}</p>
                }
                @if (message.meta?.description) {
                <p class="meta-description">{{ message.meta.description }}</p>
                }
              </div>

              <!-- Icon Mode: Small image on right -->
              @if (isIconMode(message)) {
              <div class="icon-image-container">
                <img [src]="message.meta.icon" (error)="onPreviewIconError(message)" class="icon-thumbnail" />
              </div>
              }

              <!-- Image Mode: Large image listed below/center -->
              @if (message.meta?.image && isValidImageUrl(message.meta.image) && !message.meta.imageBroken &&
              !isIconMode(message)) {
              <div class="preview-image-container">
                <img [src]="message.meta.image" (error)="onPreviewImageError(message)" class="telegram-thumbnail" />
              </div>
              }
            </div>
            }
          </div>
          }

          <!-- Plain Text -->
          @if (!isURL(message.message)) {
          <p class="msg-txt" [class.text-white]="userId === message.sender_id"
            [innerHTML]="getDisplayMessage(message.message, (message._id || message.id || message.messageId))">
          </p>
          @if (isMessageLong(message.message)) {
          <span class="read-more-link"
            (click)="toggleMessageExpand(message._id || message.id || message.messageId); $event.stopPropagation()">
            {{ isMessageExpanded(message._id || message.id || message.messageId) ? ' Show less' : ' Read more' }}
          </span>
          }
          }

        </div>
        }

        <!-- REACTIONS -->
        @if (hasReactions(message)) {
        <div class="message-reaction-container" (click)="onReactionContainerClick($event)">
          @for (agg of getDisplayedReactions(message.reactions); track agg.emoji) {
          <div class="reaction-chip" [class.reacted-by-user]="hasUserReacted(message.reactions, agg.emoji)">
            {{ agg.emoji }}
            @if (agg.count > 1) {
            <span class="reaction-count">{{ agg.count }}</span>
            }
          </div>
          }
          @if (getRemainingReactionCount(message.reactions) > 0) {
          <div class="reaction-chip remaining-count">
            +{{ getRemainingReactionCount(message.reactions) }}
          </div>
          }
        </div>
        }

        <!-- FOOTER (Time & Version) -->
        @if (!message.isUploading) {
        <div class="message-footer d-flex justify-content-between align-items-center">
          @if (message.meta?.version) {
          <div class="version-info-container position-relative">
            <span class="version-tag" (click)="toggleVersionInfo($event)" style="cursor: pointer;">V-{{
              message.meta.version }}</span>
            @if (showVersionInfo) {
            <div class="version-info-popup shadow-sm" (click)="$event.stopPropagation()">
              <p class="version-popup-main-file"><b>Versions shared:</b></p>
              <ul class="version-popup-list">
                @if (isLoadingVersionInfo) {
                <li class="d-flex justify-content-center p-3">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span class="ml-2">Loading versions...</span>
                </li>
                } @else if (message.meta?.thread && message.meta.thread.length > 0) {
                @for (threadItem of message.meta.thread; track threadItem; let j = $index) {
                <li class="d-flex flex-column">
                  <b>Version - {{ j + 1 }}:</b>
                  <span class="d-block" style="font-weight: 500; padding-left: 12px; margin-top: 2px;">
                    sent by : {{ userId === threadItem.senderId ? "you" : (threadItem.senderName || 'User') }} at :
                    {{ threadItem.createdAt | date: "hh:mm a - MMM d, y" }}
                  </span>
                </li>
                }
                } @else {
                <li class="d-flex flex-column">
                  <b>Version - {{ message.meta.version || 1 }}:</b>
                  <span class="d-block" style="font-weight: 500; padding-left: 12px; margin-top: 2px;">
                    sent by : you at : {{ message.createdAt | date:'hh:mm a - MMM d, y' }}
                  </span>
                </li>
                }
              </ul>
            </div>
            }
          </div>
          }
          <div class="time-tick-container">
            @if (message.edited || message.meta?.edited) {
            <span class="edited-tag">Edited</span>
            }
            @if (isMessageStarred()) {
            <span class="starred-icon" title="Starred">
              <svg viewBox="0 0 24 24" width="13" height="13" preserveAspectRatio="xMidYMid meet">
                <path fill="currentColor"
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z">
                </path>
              </svg>
            </span>
            }
            <span class="chat-time">{{ message.createdAt | date:'hh:mm a' }}</span>
            @if (userId === message.sender_id) {
            @if (message.pending) {
            <!-- Clock: queued in outbox, waiting for connection -->
            <svg class="pending-clock" xmlns="http://www.w3.org/2000/svg" aria-label="Waiting to send"
              style="width: 14px; height: 14px; min-width: 14px; flex-shrink: 0;" viewBox="0 0 16 16">
              <circle cx="8" cy="8" r="6.25" fill="none" stroke="#6c6968" stroke-width="1.5" />
              <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M8 4.75V8l2.25 1.5" />
            </svg>
            } @else if (isMessageSeen(message)) {
            <!-- Blue Double Tick -->
            <svg class="blue" xmlns="http://www.w3.org/2000/svg"
              style="width: 18px; height: 18px; min-width: 18px; flex-shrink: 0;" viewBox="0 0 16 16">
              <path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
            </svg>
            } @else {
            <!-- Grey Double Tick -->
            <svg xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 18px; min-width: 18px; flex-shrink: 0;"
              viewBox="0 0 16 16">
              <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
            </svg>
            }
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }

</div>